module.exports = __webpack_public_path__ + "img/reportpage.bc6c489b.png";